/**
 * /**
 *  * Generated by orval v1.0.0 🍃
 *  * Do not edit manually.
 *  * Citrus API
 *  * API for Citrus platform
 *  *\/
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ArtifactsPredictOptimizeCreate200,
  ArtifactsPredictOptimizeCreateBody,
  OptimizePredictResponse,
  OptimizeTaskCancelNotFoundResponse,
  OptimizeTaskPendingResponse,
  OptimizeTaskStatusErrorResponse,
  OptimizeTaskStatusNotFoundResponse,
  OptimizeTaskStatusResponse
} from '../../models';

import { customInstance } from '../../../axios-instance';




/**
 * Check status of Optimize async task. Returns report when complete (SUCCESS), pending status while processing, or error if failed. Poll every 10 seconds until status is SUCCESS or FAILURE.
 * @summary Get Optimize task status
 */
export const artifactsOptimizeTaskRetrieve = (
    taskId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<OptimizeTaskStatusResponse | OptimizeTaskPendingResponse>(
      {url: `/api/artifacts/optimize/task/${taskId}/`, method: 'GET', signal
    },
      );
    }
  

export const getArtifactsOptimizeTaskRetrieveQueryKey = (taskId: string,) => {
    return [`/api/artifacts/optimize/task/${taskId}/`] as const;
    }

    
export const getArtifactsOptimizeTaskRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof artifactsOptimizeTaskRetrieve>>, TError = OptimizeTaskStatusNotFoundResponse | OptimizeTaskStatusErrorResponse>(taskId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof artifactsOptimizeTaskRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getArtifactsOptimizeTaskRetrieveQueryKey(taskId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof artifactsOptimizeTaskRetrieve>>> = ({ signal }) => artifactsOptimizeTaskRetrieve(taskId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(taskId),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof artifactsOptimizeTaskRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ArtifactsOptimizeTaskRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof artifactsOptimizeTaskRetrieve>>>
export type ArtifactsOptimizeTaskRetrieveQueryError = OptimizeTaskStatusNotFoundResponse | OptimizeTaskStatusErrorResponse


export function useArtifactsOptimizeTaskRetrieve<TData = Awaited<ReturnType<typeof artifactsOptimizeTaskRetrieve>>, TError = OptimizeTaskStatusNotFoundResponse | OptimizeTaskStatusErrorResponse>(
 taskId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof artifactsOptimizeTaskRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof artifactsOptimizeTaskRetrieve>>,
          TError,
          Awaited<ReturnType<typeof artifactsOptimizeTaskRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useArtifactsOptimizeTaskRetrieve<TData = Awaited<ReturnType<typeof artifactsOptimizeTaskRetrieve>>, TError = OptimizeTaskStatusNotFoundResponse | OptimizeTaskStatusErrorResponse>(
 taskId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof artifactsOptimizeTaskRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof artifactsOptimizeTaskRetrieve>>,
          TError,
          Awaited<ReturnType<typeof artifactsOptimizeTaskRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useArtifactsOptimizeTaskRetrieve<TData = Awaited<ReturnType<typeof artifactsOptimizeTaskRetrieve>>, TError = OptimizeTaskStatusNotFoundResponse | OptimizeTaskStatusErrorResponse>(
 taskId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof artifactsOptimizeTaskRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Optimize task status
 */

export function useArtifactsOptimizeTaskRetrieve<TData = Awaited<ReturnType<typeof artifactsOptimizeTaskRetrieve>>, TError = OptimizeTaskStatusNotFoundResponse | OptimizeTaskStatusErrorResponse>(
 taskId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof artifactsOptimizeTaskRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getArtifactsOptimizeTaskRetrieveQueryOptions(taskId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Cancel a running Optimize task. This sends a cancellation request to the R API to stop computation and deletes the local task tracking record.
 * @summary Cancel Optimize task
 */
export const artifactsOptimizeTaskDestroy = (
    taskId: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/artifacts/optimize/task/${taskId}/`, method: 'DELETE'
    },
      );
    }
  


export const getArtifactsOptimizeTaskDestroyMutationOptions = <TError = OptimizeTaskCancelNotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof artifactsOptimizeTaskDestroy>>, TError,{taskId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof artifactsOptimizeTaskDestroy>>, TError,{taskId: string}, TContext> => {

const mutationKey = ['artifactsOptimizeTaskDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof artifactsOptimizeTaskDestroy>>, {taskId: string}> = (props) => {
          const {taskId} = props ?? {};

          return  artifactsOptimizeTaskDestroy(taskId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ArtifactsOptimizeTaskDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof artifactsOptimizeTaskDestroy>>>
    
    export type ArtifactsOptimizeTaskDestroyMutationError = OptimizeTaskCancelNotFoundResponse

    /**
 * @summary Cancel Optimize task
 */
export const useArtifactsOptimizeTaskDestroy = <TError = OptimizeTaskCancelNotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof artifactsOptimizeTaskDestroy>>, TError,{taskId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof artifactsOptimizeTaskDestroy>>,
        TError,
        {taskId: string},
        TContext
      > => {

      const mutationOptions = getArtifactsOptimizeTaskDestroyMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Start Meridian MMM optimization and return task_id for polling.
        Meridian takes ~10 minutes to run.
        Use GET /api/artifacts/optimize/task/{task_id}/ to check status and get report when complete.

        Supports three execution modes via optional 'mode' field:
        - 'new' (default): Create new artifact with 24h expiration
        - 'explore': Create temporary variant of existing artifact (requires 'old_artifact_id')
        - 'rerun': Refresh hashes on existing artifact without retraining (requires 'id')

        Explore mode returns report with 'old_artifact_id' and 'new_artifact_id' for use with /replace/ endpoint.

        **Request Body**: Use write-only fields for input:
        - `project_solution_id`: number (not nested object)
        - `dependent_driver_id`: number (not nested object)
        - `control_driver_ids`: number[] (not nested array of objects)
        - `channel_driver_inputs`: array of {channel_id, spend_dataset_id, etc.}
        - `model_object`: Blob | null (file upload, not string path)
        - Do NOT include `id` field (server-generated)
        
 * @summary Start Optimize prediction (async)
 */
export const artifactsPredictOptimizeCreate = (
    artifactsPredictOptimizeCreateBody: ArtifactsPredictOptimizeCreateBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ArtifactsPredictOptimizeCreate200>(
      {url: `/api/artifacts/predict/optimize`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: artifactsPredictOptimizeCreateBody, signal
    },
      );
    }
  


export const getArtifactsPredictOptimizeCreateMutationOptions = <TError = OptimizePredictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof artifactsPredictOptimizeCreate>>, TError,{data: ArtifactsPredictOptimizeCreateBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof artifactsPredictOptimizeCreate>>, TError,{data: ArtifactsPredictOptimizeCreateBody}, TContext> => {

const mutationKey = ['artifactsPredictOptimizeCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof artifactsPredictOptimizeCreate>>, {data: ArtifactsPredictOptimizeCreateBody}> = (props) => {
          const {data} = props ?? {};

          return  artifactsPredictOptimizeCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ArtifactsPredictOptimizeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof artifactsPredictOptimizeCreate>>>
    export type ArtifactsPredictOptimizeCreateMutationBody = ArtifactsPredictOptimizeCreateBody
    export type ArtifactsPredictOptimizeCreateMutationError = OptimizePredictResponse

    /**
 * @summary Start Optimize prediction (async)
 */
export const useArtifactsPredictOptimizeCreate = <TError = OptimizePredictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof artifactsPredictOptimizeCreate>>, TError,{data: ArtifactsPredictOptimizeCreateBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof artifactsPredictOptimizeCreate>>,
        TError,
        {data: ArtifactsPredictOptimizeCreateBody},
        TContext
      > => {

      const mutationOptions = getArtifactsPredictOptimizeCreateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    